import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import WidgetPhotosGridCircleProps from '../widget-photos-grid-circle.props';
import WidgetPhotosGridCircleDesktopBasic from './components/widget-photos-grid-circle-desktop-basic';
import SrcSet from '../../../../components/src-set/src-set';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-photos-grid-circle-desktop.scss';

const WidgetPhotosGridCircleDesktop: React.FC<WidgetPhotosGridCircleProps> = ({ config, data }) => {
    const [WidgetCarouselComponent, setWidgetCarousel] = useState<React.ComponentType<any>>(() => WidgetPhotosGridCircleDesktopBasic);

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 0 },
            items: 5
        }
    };

    return (
        <div className="w-photos-grid-circle-d">
            <WidgetCarouselComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                renderButtonGroupOutside={true}
                customButtonGroup={false}
                arrows={true}
                autoPlay={false}
                slidesToSlide={5}
                className="w-photos-grid-circle-d__list"
                itemClass="w-photos-grid-circle-d__list__item"
            >
                { data.map((item, idx) => (
                    <a href={item.url}
                        key={String(idx)}
                        target={item.target}
                        rel={getLinkRelByTarget(item.target)}
                    >
                        <div className="w-photos-grid-circle-d__list__item__main">
                            <div
                                className={classNames(
                                    {
                                        'w-photos-grid-circle-d__list__item__image': true,
                                        'w-photos-grid-circle-d__list__item__image--no-frame': config?.viewType?.noFrame
                                    }
                                )}
                            >
                                <SrcSet
                                    images={item.modifiedImg}
                                    alt={item.title.trim() || `Obrazek ${idx}`}
                                />
                            </div>
                        </div>
                        <div className="w-photos-grid-circle-d__list__item__title">
                            {item.title}
                        </div>
                    </a>
                ))}
            </WidgetCarouselComponent>
        </div>
    );
};

export default WidgetPhotosGridCircleDesktop;
